import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const CongratulationIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="150" height="151" viewBox="0 0 150 151" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x="115.025"
      y="78.7802"
      width="14.4966"
      height="2"
      rx="1"
      transform="rotate(5.37759 115.025 78.7802)"
      fill="#A89DFB"
    />
    <rect
      x="102.168"
      y="102.544"
      width="11.8951"
      height="2"
      rx="1"
      transform="rotate(32.6548 102.168 102.544)"
      fill="#A89DFB"
    />
    <rect
      x="29.0664"
      y="37.9998"
      width="12.3218"
      height="2"
      rx="1"
      transform="rotate(24.5662 29.0664 37.9998)"
      fill="#A89DFB"
    />
    <rect
      x="75.9062"
      y="28.9287"
      width="13.1066"
      height="2"
      rx="1"
      transform="rotate(-86.8543 75.9062 28.9287)"
      fill="#A89DFB"
    />
    <rect
      x="74.834"
      y="133.179"
      width="10.8477"
      height="2"
      rx="1"
      transform="rotate(-94.9519 74.834 133.179)"
      fill="#A89DFB"
    />
    <rect
      x="14.0215"
      y="84.0607"
      width="18.8679"
      height="2"
      rx="1"
      transform="rotate(-7.65176 14.0215 84.0607)"
      fill="#A89DFB"
    />
    <rect
      x="110.592"
      y="41.5673"
      width="19.8003"
      height="2"
      rx="1"
      transform="rotate(-33.6625 110.592 41.5673)"
      fill="#A89DFB"
    />
    <rect
      x="116.244"
      y="57.5219"
      width="4.81498"
      height="2"
      rx="1"
      transform="rotate(-19.121 116.244 57.5219)"
      fill="#3B3184"
    />
    <rect
      x="48.3984"
      y="128.512"
      width="7.29178"
      height="2"
      rx="1"
      transform="rotate(-66.9249 48.3984 128.512)"
      fill="#3B3184"
    />
    <rect
      x="24.5"
      y="101.448"
      width="4.03117"
      height="2"
      rx="1"
      transform="rotate(-22.6968 24.5 101.448)"
      fill="#3B3184"
    />
    <rect
      x="27.2285"
      y="59.629"
      width="6.43277"
      height="2"
      rx="1"
      transform="rotate(13.9775 27.2285 59.629)"
      fill="#3B3184"
    />
    <rect
      x="95.8066"
      y="31.9424"
      width="7.29178"
      height="2"
      rx="1"
      transform="rotate(-65.5251 95.8066 31.9424)"
      fill="#3B3184"
    />
    <rect
      x="99.3984"
      y="125.55"
      width="7.29178"
      height="2"
      rx="1"
      transform="rotate(-123.4 99.3984 125.55)"
      fill="#3B3184"
    />
    <rect
      x="48.4473"
      y="25.9227"
      width="7.29178"
      height="2"
      rx="1"
      transform="rotate(-128.24 48.4473 25.9227)"
      fill="#3B3184"
    />
    <rect
      x="125.74"
      y="101.737"
      width="4.75348"
      height="2"
      rx="1"
      transform="rotate(-141.728 125.74 101.737)"
      fill="#3B3184"
    />
    <rect
      x="34.4316"
      y="108.613"
      width="10.4064"
      height="2"
      rx="1"
      transform="rotate(-34.3696 34.4316 108.613)"
      fill="#A89DFB"
    />
    <path
      d="M64.5547 77.5332L77.6826 78.8422L75.5447 122.6L68.4367 104.769L60.702 116.171L64.5547 77.5332Z"
      fill="url(#paint0_linear_7934_47500)"
    />
    <path
      d="M68.7734 76.1186L81.5263 73.6781L94.0916 109.534L82.0776 100.301L78.8232 113.625L68.7734 76.1186Z"
      fill="#6450F7"
    />
    <path
      d="M74.7373 43.0005C74.2632 42.0787 73.4498 41.4706 72.5257 41.4706C71.6018 41.4706 70.7884 42.0785 70.3143 43.0001C69.6706 42.2677 68.7626 41.9511 67.8701 42.2585C66.9777 42.566 66.3144 43.4239 66.0419 44.472C65.2728 43.9785 64.3317 43.9749 63.5316 44.5688C62.7314 45.1627 62.2634 46.2122 62.2113 47.3152C61.369 47.0944 60.4593 47.404 59.8058 48.244C59.1526 49.0838 58.9118 50.2531 59.0834 51.3359C58.2255 51.403 57.4092 52.0047 56.9473 53.0333C56.4855 54.0619 56.4882 55.2716 56.872 56.2603C56.0566 56.6105 55.3892 57.4634 55.15 58.6108C54.911 59.7583 55.1573 60.9259 55.7272 61.7533C55.0101 62.3629 54.5371 63.4088 54.5371 64.5967C54.5371 65.7844 55.0098 66.8302 55.7267 67.4398C55.157 68.2672 54.9108 69.4346 55.15 70.5819C55.389 71.7292 56.0564 72.5821 56.8718 72.9323C56.4879 73.9211 56.4851 75.1308 56.947 76.1595C57.4089 77.1882 58.2252 77.7898 59.0831 77.8569C58.9114 78.9398 59.1523 80.1092 59.8056 80.9492C60.459 81.7891 61.3688 82.0987 62.211 81.8779C62.2631 82.981 62.7311 84.0305 63.5313 84.6244C64.3313 85.2183 65.2723 85.2147 66.0414 84.7213C66.3139 85.7694 66.9773 86.6274 67.8696 86.9348C68.7623 87.2422 69.6703 86.9256 70.3139 86.1929C70.7881 87.1148 71.6017 87.7229 72.5257 87.7229C73.4496 87.7229 74.263 87.115 74.7372 86.1934C75.3807 86.9258 76.2889 87.2424 77.1812 86.935C78.0735 86.6275 78.7372 85.7696 79.0096 84.7215C79.7787 85.215 80.7195 85.2186 81.52 84.6247C82.3202 84.0308 82.7882 82.9813 82.8403 81.8783C83.6825 82.099 84.592 81.7894 85.2453 80.9495C85.8986 80.1097 86.1396 78.9404 85.9679 77.8576C86.8259 77.7905 87.6423 77.1888 88.1041 76.1602C88.566 75.1315 88.5634 73.9218 88.1795 72.933C88.9949 72.5828 89.6621 71.7299 89.9011 70.5826C90.1401 69.4352 89.894 68.2676 89.3241 67.4402C90.0412 66.8307 90.5143 65.7847 90.5143 64.5968C90.5143 63.409 90.0415 62.3632 89.3244 61.7536C89.894 60.9262 90.1401 59.7588 89.9011 58.6116C89.6621 57.4643 88.9952 56.6116 88.1798 56.2613C88.5637 55.2725 88.5663 54.0627 88.1045 53.034C87.6426 52.0054 86.8263 51.4037 85.9682 51.3366C86.1399 50.2537 85.8993 49.0843 85.246 48.2443C84.5923 47.4044 83.6828 47.0948 82.8406 47.3156C82.7885 46.2125 82.3205 45.163 81.5204 44.5691C80.7202 43.9752 79.779 43.9788 79.0099 44.4722C78.7376 43.4241 78.0742 42.5661 77.1818 42.2586C76.2892 41.9512 75.381 42.2679 74.7373 43.0005Z"
      fill="white"
    />
    <path
      d="M84.4323 64.0338C84.4323 73.0172 78.6538 80.2996 71.5257 80.2996H68.5935L58.6191 64.0338L68.2948 47.7679H71.5257C78.6538 47.7679 84.4323 55.0504 84.4323 64.0338Z"
      fill="#4B3DB2"
    />
    <ellipse cx="70.3168" cy="64.0338" rx="12.6293" ry="16.2658" fill="#6450F7" />
    <path d="M69.5164 72.0274V59.1874L70.3964 59.8674H66.5364V57.4274H72.3364V72.0274H69.5164Z" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_7934_47500"
        x1="72.2204"
        y1="78.2976"
        x2="63.6156"
        y2="105.986"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.06" stopColor="#4B3DB2" />
        <stop offset="1" stopColor="#6450F7" />
      </linearGradient>
    </defs>
  </svg>
)
